import { ITEM_STATE_PLACEHOLDER } from "../../constants";

export default (size, offset = 0) =>
  [...new Array(size)].map((_, i) => ({
    id: `${ITEM_STATE_PLACEHOLDER}_${i + offset}`,
    itemState: ITEM_STATE_PLACEHOLDER
  }));
